import PropTypes from 'prop-types';
import React from 'react';

const Stepper = ({ width, children }) => {
  return (
    <>
      <div className="stepper__wrapper">{children}</div>

      <style jsx>{`
        .stepper__wrapper {
          display: flex;
          flex-wrap: wrap;
          margin: 15px auto;
          width: ${width || '100%'};
          max-width: 800px;
        }
      `}</style>
    </>
  );
};

Stepper.propTypes = {
  children: PropTypes.any,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default Stepper;
